import $ from '../$';
import merge from '../functions/merge';
import { JQ } from '../JQ';
import './each';
import './get';
$.fn.find = function (selector) {
    const foundElements = [];
    this.each((_, element) => {
        merge(foundElements, $(element.querySelectorAll(selector)).get());
    });
    return new JQ(foundElements);
};
